// extracted by mini-css-extract-plugin
export var address = "address-module--address--iS06T";
export var addressG = "address-module--addressG--SUq8S";
export var anchor = "address-module--anchor--Hdh+P";